// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { getToken, getStation } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import Page from 'statsradio/components/page/Page';
import * as Routes from 'statsradio/helpers/constant/Routes';
import StreamingAPI from './services/StreamingAPI';
import Stream from './domain/Stream';

export const STREAMS_PAGE_ID = 'streams-page';

type Props = {
  t: any;
  token: string,
  callSign: string,
  history: any;
};

type State = {
  streams: Stream[];
}

export class StreamingPage extends Component<Props, State> {

  state = {
    streams: [],
  };

  async componentDidMount() {
    this.fetchStreams();
  }

  async componentDidUpdate(prevProps: Props) {
    if (prevProps.callSign !== this.props.callSign) {
      this.fetchStreams();
    }
  }

  async fetchStreams() {
    const { token, callSign } = this.props;
    const streams = await StreamingAPI.fetchStreams(token, callSign);

    if (streams.length === 1) {
      this.navigateToStream(streams[0]);
    }

    this.setState({ streams });
  }

  navigateToStream = (stream: Stream) => {
    const { history } = this.props;
    history.push({
      pathname: Routes.STREAM(stream.reference),
      state: { stream },
    });
  }

  render() {
    const { t } = this.props;
    const { streams } = this.state;

    return (
      <Page useThemeV2 title={t('streamingPageTitle')} id={STREAMS_PAGE_ID}>
        <table>
          <thead>
            <tr>
              <th>{t('streamUrl')}</th>
              <th>{t('serverType')}</th>
              <th>{t('mediaType')}</th>
            </tr>
          </thead>
          <tbody>
            { streams.map(stream => (
              <tr key={stream.url} onClick={() => this.navigateToStream(stream)}>
                <th>{stream.url}</th>
                <th>{stream.serverType}</th>
                <th>{stream.mediaType}</th>
              </tr>
            ))}
          </tbody>
        </table>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: getToken(state),
    callSign: getStation(state),
  };
}

export default translate('streaming')(connect(mapStateToProps)(withRouter(StreamingPage)));




// WEBPACK FOOTER //
// ./src/statsradio/modules/streaming/StreamingPage.js